import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import ClickableTableCell from '../shared/ClickableTableCell';

const TableCell = ({ row, column, ...restProps }) => {
    const columnName = column.name;

    if (columnName === 'name') {
        return <ClickableTableCell href={`/office/${row.id}`} showText={row[columnName]} />;
    }

    if (columnName === 'bossName' && !!row.bossID && !!row[columnName]) {
        return <ClickableTableCell href={`/employee/${row.bossID}/info`} showText={row[columnName]} />;
    }

    return (
        <Table.Cell {...restProps}>
            <div className='d-flex align-items-center h-100 justify-content-end'>{row[columnName]}</div>
        </Table.Cell>
    );
};

export default TableCell;
